export default "__VITE_ASSET__29c093d5__"